module.exports = __webpack_public_path__ + "453045bfbd0facbb5aa9080d38c90535.jpg";